(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bundle-aplus"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-bundle-aplus]').forEach((block) => {
      const body = block.querySelector('[data-bundle-aplus-body]');
      const error = block.querySelector('[data-bundle-aplus-error]');
      const errorLink = block.querySelector('[data-bundle-aplus-error-link]');
      if (!body) return;
      const overviewNodes = [...body.childNodes].map((node) => node.cloneNode(true));
      let lastRequest = 0;
      const safeRichText = (html) => {
        const parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
        parsed.querySelectorAll('script, object, embed, form, link, meta, svg, math, noscript, template').forEach((node) => node.remove());
        parsed.querySelectorAll('*').forEach((node) => {
          for (const attribute of [...node.attributes]) {
            const name = attribute.name.toLowerCase();
            const value = attribute.value.trim();
            if (name.startsWith('on') || name === 'srcdoc' || name === 'formaction' || name === 'xlink:href' ||
                (['href', 'src', 'poster', 'srcset'].includes(name) && /^(javascript|data):/i.test(value)) ||
                (name === 'style' && /(url\s*\(|expression\s*\(|@import)/i.test(value))) node.removeAttribute(attribute.name);
          }
          if (node.tagName === 'IFRAME') {
            try {
              const url = new URL(node.getAttribute('src') || '', location.href);
              if (url.protocol !== 'https:' || !['www.youtube.com', 'www.youtube-nocookie.com', 'player.vimeo.com'].includes(url.hostname)) node.remove();
            } catch { node.remove(); }
          }
        });
        return parsed.body;
      };
      const clear = () => {
        window.SimpProdetailPublishedViewV2?.unmount?.(body);
        body.replaceChildren();
        error.hidden = true;
        error.textContent = '';
        if (errorLink) { errorLink.hidden = true; errorLink.removeAttribute('href'); }
      };
      const mountViews = (container) => container.querySelectorAll('[data-prodetail-aplus-view][data-prodetail-selected-source="agent"][data-prodetail-state="ready"]').forEach((view) => window.SimpProdetailPublishedViewV2?.mount?.(view));
      document.addEventListener('simp:bundle-product-data', (event) => {
        const detail = event.detail || {};
        if (detail.contextId && detail.contextId !== block.dataset.bundleContextId) return;
        const requestId = Number(detail.requestId || 0);
        if (requestId && requestId < lastRequest) return;
        if (requestId) lastRequest = requestId;
        clear();
        if (detail.isBundle) {
          body.append(...overviewNodes.map((node) => node.cloneNode(true)));
          mountViews(body);
          return;
        }
        const aplus = detail.product?.aplus || {};
        const rich = typeof aplus.richText === 'string' && aplus.richText.trim().length > 0;
        const bundle = aplus.agent;
        const agent = bundle?.schema === 'simpshops.aplus.page-bundle@2' && bundle?.contract_version === 2 && Boolean(bundle?.html);
        const source = aplus.source || (rich !== agent ? rich ? 'shopify_richtext' : 'agent' : null);
        if (source === 'shopify_richtext' && rich) {
          const content = document.createElement('div');
          content.className = 'bundle-aplus__rte rte';
          content.append(...safeRichText(aplus.richText).childNodes);
          body.append(content);
        } else if (source === 'agent' && agent) {
          const view = document.createElement('div');
          view.dataset.prodetailAplusView = '';
          view.dataset.prodetailSelectedSource = 'agent';
          view.dataset.prodetailState = 'ready';
          view.dataset.prodetailProductGid = String(bundle.product_gid || '');
          view.dataset.prodetailRootHash = String(aplus.rootHash || '');
          view.dataset.prodetailSourceHash = String(bundle.source_revision_hash || '');
          view.dataset.prodetailDeliveryHash = String(bundle.revision_hash || '');
          view.dataset.prodetailLocale = String(bundle.locale || aplus.resolvedLocale || '');
          body.append(view);
          try {
            window.SimpProdetailPublishedViewV2?.render?.(view, bundle, { product_gid: view.dataset.prodetailProductGid, locale: view.dataset.prodetailLocale, root_hash: view.dataset.prodetailRootHash });
          } catch {
            body.replaceChildren();
            error.hidden = false;
            error.textContent = 'Enhanced content is unavailable.';
          }
        } else if (source || aplus.state === 'unavailable') {
          error.hidden = false;
          error.textContent = 'Enhanced content is unavailable.';
          if (errorLink && detail.product?.url) { errorLink.href = detail.product.url; errorLink.hidden = false; }
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_bundle-components"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-bundle-components]').forEach((block) => {
      const configNode = block.querySelector('[data-bundle-components-config]');
      const list = block.querySelector('[data-bundle-components-list]');
      const countNode = block.querySelector('[data-bundle-components-count]');
      const errorNode = block.querySelector('[data-bundle-components-error]');
      if (!list) return;
      let selectionRequestId = 0;
      let config;
      try {
        config = JSON.parse(configNode?.textContent || JSON.stringify(window.simpBundlePreviewConfig || {}));
      } catch {
        return;
      }
      const variantFor = (id) => (Array.isArray(config?.parentVariants) ? config.parentVariants : []).find((entry) =>
        String(entry.variantId || '').split('/').pop() === String(id).split('/').pop()) || null;
      const selectCard = (card) => {
        list.querySelectorAll('[aria-pressed="true"]').forEach((node) => node.setAttribute('aria-pressed', 'false'));
        card.setAttribute('aria-pressed', 'true');
      };
      const reportError = (message) => {
        if (!errorNode) return;
        errorNode.textContent = message;
        errorNode.hidden = !message;
      };
      const makeCard = (item, selected) => {
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'bundle-components__item';
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          const image = document.createElement('img');
          if (item.imageUrl || item.image_url) {
            image.src = item.imageUrl || item.image_url;
            image.alt = item.productTitle || item.product_title || 'Bundle accessory';
            image.loading = 'lazy';
            card.append(image);
          }
          const title = document.createElement('strong');
          title.textContent = item.isBundle ? 'Bundle' : item.productTitle || item.product_title || 'Bundle accessory';
          card.append(title);
          if (!item.isBundle) {
            const quantity = document.createElement('small');
            quantity.textContent = `${Math.max(1, Number(item.quantity) || 1)} × Bundle accessory`;
            card.append(quantity);
          }
          card.addEventListener('click', async () => {
            const requestId = ++selectionRequestId;
            reportError('');
            const detail = {
              isBundle: Boolean(item.isBundle),
              productHandle: item.productHandle || item.product_handle || '',
              productTitle: item.productTitle || item.product_title || 'Bundle accessory',
              imageUrl: item.imageUrl || item.image_url || '',
              contextDescriptionHtml: item.contextDescriptionHtml || '',
              contentPolicy: item.contentPolicy || null,
              mediaUrls: Array.isArray(item.mediaUrls) ? item.mediaUrls : [],
            };
            if (item.isBundle) {
              selectCard(card);
              document.dispatchEvent(new CustomEvent('simp:bundle-product-data', { detail: { contextId: `gid://shopify/Product/${block.dataset.bundleParentProductId}`, isBundle: true, config, requestId } }));
              return;
            }
            if (!detail.productHandle) { reportError('Product details are unavailable.'); return; }
            card.disabled = true;
            try {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}products/${encodeURIComponent(detail.productHandle)}?view=bundle-data`);
              if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
              const product = await response.json();
              if (!product || !Array.isArray(product.images) || !product.aplus) throw new Error('Incomplete product details');
              if (requestId !== selectionRequestId) return;
              selectCard(card);
              document.dispatchEvent(new CustomEvent('simp:bundle-product-data', { detail: { ...detail, contextId: `gid://shopify/Product/${block.dataset.bundleParentProductId}`, product, requestId } }));
            } catch {
              if (requestId === selectionRequestId) reportError('Product details could not be loaded. Please try again.');
            } finally {
              card.disabled = false;
            }
          });
          return card;
        };
      const renderVariant = (id) => {
        if (!config) return;
        const variant = variantFor(id);
        const snapshots = Array.isArray(config?.components) ? config.components : [];
        const mapped = Array.isArray(variant?.components) ? variant.components : [];
        const components = mapped.map((item) => {
          const snapshot = snapshots.find((entry) => String(entry.productId).split('/').pop() === String(item.productId).split('/').pop()) || {};
          const policy = snapshot.contentPolicy || {};
          const mediaMode = policy.mediaMode || 'inherit';
          const overrideMedia = Array.isArray(snapshot.mediaUrls) ? snapshot.mediaUrls : [];
          return {
            ...snapshot,
            ...item,
            productTitle: policy.titleMode === 'override' && snapshot.contextTitle ? snapshot.contextTitle : item.productTitle || snapshot.productTitle,
            imageUrl: mediaMode === 'hidden' ? '' : mediaMode === 'override' ? (overrideMedia[0] || '') : (item.imageUrl || snapshot.imageUrl || ''),
            mediaUrls: mediaMode === 'hidden' ? [] : mediaMode === 'override' ? overrideMedia : [],
          };
        });
        const totalQuantity = components.reduce((sum, item) => sum + Math.max(1, Number(item.quantity) || 1), 0);
        if (countNode) countNode.textContent = `Includes ${totalQuantity} accessory item${totalQuantity === 1 ? '' : 's'}`;
        const bundleItem = { productTitle: config.title || 'Bundle', imageUrl: config.imageUrl || '', mediaUrls: [config.imageUrl, ...(config.galleryImages || [])].filter(Boolean), isBundle: true };
        list.replaceChildren(makeCard(bundleItem, true), ...components.map((item) => makeCard(item, false)));
        reportError(variant ? '' : 'This bundle variant has no verified component mapping.');
        document.dispatchEvent(new CustomEvent('simp:bundle-product-data', { detail: { contextId: `gid://shopify/Product/${block.dataset.bundleParentProductId}`, isBundle: true, config, requestId: ++selectionRequestId } }));
      };
      renderVariant(block.dataset.bundleParentVariantId);
      document.addEventListener('simp:bundle-preview-config', (event) => {
        config = event.detail || {};
        renderVariant(block.dataset.bundleParentVariantId);
      });
      document.addEventListener('variant:update', (event) => {
        if (String(event.detail?.data?.productId) !== block.dataset.bundleParentProductId) return;
        renderVariant(event.detail?.resource?.id);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_bundle-description"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-bundle-description-config]').forEach((node) => {
      const root = node.closest('[data-bundle-description-config]')?.parentElement;
      if (!root) return;
      let config;
      try {
        config = JSON.parse(node.textContent || '{}');
        if (!config.title && window.simpBundlePreviewConfig) config = window.simpBundlePreviewConfig;
      } catch {
        return;
      }
      const summary = root.querySelector('[data-bundle-description-summary]');
      const selectedTitle = root.querySelector('[data-bundle-selected-title]');
      const usage = root.querySelector('[data-bundle-description-usage]');
      const usageTitle = root.querySelector('[data-bundle-description-usage-title]');
      const productLink = root.querySelector('[data-bundle-product-link]');
      let overviewSummary = config.description || summary?.innerHTML || '';
      let overviewUsage = config.usageInstructions || usage?.innerHTML || '';
      const safeHtmlNodes = (html) => {
        const parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
        parsed.querySelectorAll('script, object, embed, form, link, meta, svg, math, noscript, template').forEach((node) => node.remove());
        parsed.querySelectorAll('*').forEach((element) => {
          for (const attribute of [...element.attributes]) {
            const name = attribute.name.toLowerCase();
            const value = attribute.value.trim();
            if (name.startsWith('on') || name === 'srcdoc' || name === 'formaction' || name === 'xlink:href' ||
                (['href', 'src', 'poster', 'srcset'].includes(name) && /^(javascript|data):/i.test(value)) ||
                (name === 'style' && /(url\s*\(|expression\s*\(|@import)/i.test(value))) element.removeAttribute(attribute.name);
          }
          if (element.tagName === 'IFRAME') {
            try {
              const url = new URL(element.getAttribute('src') || '', location.href);
              if (url.protocol !== 'https:' || !['www.youtube.com', 'www.youtube-nocookie.com', 'player.vimeo.com'].includes(url.hostname)) element.remove();
            } catch { element.remove(); }
          }
        });
        return [...parsed.body.childNodes].map((node) => node.cloneNode(true));
      };
      const replaceSafeHtml = (target, html) => target?.replaceChildren(...safeHtmlNodes(html));
      if (summary && config.description) summary.textContent = config.description;
      if (usage && config.usageInstructions) usage.textContent = config.usageInstructions;
      let lastRequest = 0;
      const setBundle = () => {
        if (selectedTitle) {
          selectedTitle.textContent = '';
          selectedTitle.hidden = true;
        }
        if (summary) summary.textContent = overviewSummary;
        if (usage) usage.textContent = overviewUsage;
        if (usageTitle) usageTitle.textContent = 'Usage instructions';
        if (productLink) productLink.hidden = true;
      };
      setBundle();
      document.addEventListener('simp:bundle-preview-config', (event) => {
        config = event.detail || {};
        overviewSummary = config.description || '';
        overviewUsage = config.usageInstructions || '';
        if (summary) summary.textContent = overviewSummary;
        if (usage) usage.textContent = overviewUsage;
      });
      document.addEventListener('simp:bundle-product-data', (event) => {
        const detail = event.detail || {};
        const requestId = Number(detail.requestId || 0);
        if (requestId && requestId < lastRequest) return;
        if (requestId) lastRequest = requestId;
        if (detail.isBundle) {
          setBundle();
          return;
        }
        const product = detail.product || {};
        const policy = detail.contentPolicy || {};
        const descriptionMode = policy.descriptionMode || 'inherit';
        if (selectedTitle) {
          selectedTitle.textContent = product.title || detail.productTitle || 'Bundle accessory';
          selectedTitle.hidden = false;
        }
        if (summary && descriptionMode === 'override') {
          replaceSafeHtml(summary, detail.contextDescriptionHtml || '');
        } else if (summary && descriptionMode !== 'hidden') {
          replaceSafeHtml(summary, product.description || product.body_html || '');
        } else if (summary) {
          summary.textContent = '';
        }
        if (usage) usage.innerHTML = '';
        if (usageTitle) usageTitle.textContent = '';
        if (productLink) {
          productLink.hidden = !product.url;
          if (product.url) productLink.href = new URL(product.url, location.origin).toString();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_bundle-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-bundle-media-gallery]').forEach((gallery) => {
      const grid = gallery.querySelector('[data-bundle-media-grid]');
      if (!grid) return;
      const bundleMarkup = grid.innerHTML;

      const renderImages = (images, title) => {
        const urls = Array.isArray(images) ? [...new Set(images.filter(Boolean))] : [];
        if (!urls.length) {
          const empty = document.createElement('p');
          empty.className = 'bundle-media-gallery__empty';
          empty.textContent = 'No product images available.';
          grid.replaceChildren(empty);
          return;
        }
        grid.replaceChildren(
          ...urls.map((url, index) => {
            const figure = document.createElement('figure');
            figure.className = `bundle-media-gallery__item${index === 0 ? ' bundle-media-gallery__item--hero' : ''}`;
            const image = document.createElement('img');
            image.src = url;
            image.alt = title || 'Bundle product';
            image.loading = index === 0 ? 'eager' : 'lazy';
            image.width = 1600;
            image.height = 1600;
            figure.append(image);
            return figure;
          })
        );
      };

      const renderBundle = (config) => {
        const gallery = Array.isArray(config.galleryImages) ? config.galleryImages.map((item) => typeof item === 'string' ? item : item?.url) : [];
        const componentImages = Array.isArray(config.components) ? config.components.flatMap((item) => item.mediaUrls?.length ? item.mediaUrls : [item.imageUrl || item.image_url]) : [];
        renderImages([config.imageUrl, ...gallery, ...componentImages], config.title || 'Bundle');
      };

      if (window.simpBundlePreviewConfig) renderBundle(window.simpBundlePreviewConfig);
      document.addEventListener('simp:bundle-preview-config', (event) => renderBundle(event.detail || {}));

      document.addEventListener('simp:bundle-product-data', (event) => {
        const detail = event.detail || {};
        if (detail.isBundle) {
          const config = detail.config || window.simpBundlePreviewConfig;
          if (config) renderBundle(config);
          else grid.innerHTML = bundleMarkup;
          return;
        }
        const product = detail.product || {};
        const mode = detail.contentPolicy?.mediaMode || 'inherit';
        const images = mode === 'hidden' || mode === 'override'
          ? (detail.mediaUrls || [])
          : (product.images || [product.featured_image]);
        renderImages(images, detail.productTitle || product.title);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function initParallax() {
    var cards = document.querySelectorAll('.simp-card--parallax');
    if (!cards.length) return;

    // IntersectionObserver：只对可见卡片执行 scroll 计算
    var visibleCards = new Set();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          visibleCards.add(entry.target);
        } else {
          visibleCards.delete(entry.target);
        }
      });
    }, { threshold: 0 });

    cards.forEach(function (card) {
      observer.observe(card);
    });

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        visibleCards.forEach(function (card) {
          var bg = card.querySelector('[data-parallax]');
          if (!bg) return;

          var rect = card.getBoundingClientRect();
          var vh = window.innerHeight;

          // progress: 0（卡片底部进入视口）→ 1（卡片顶部离开视口）
          var progress = 1 - (rect.bottom / (vh + rect.height));
          progress = Math.max(0, Math.min(1, progress));

          // speed 从 CSS 变量读取，默认 0.3
          var speed = parseFloat(bg.dataset.speed || '0.3');


          // 位移范围：-speed*100px ～ +speed*100px
          var offset = (progress - 0.5) * speed * 600;
          bg.style.transform = 'translateY(' + offset + 'px)';
        });
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll(); // 初始化
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-category-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function initOrbit() {
    document.querySelectorAll('.simp-category-card__link--l5-border-orbit').forEach(function (link) {
      var rect = link.querySelector('.simp-category-card__orbit-rect');
      var wrapper = link.querySelector('.simp-category-card__content-wrap');
      if (!rect || !wrapper) return;

      function setDash() {
        var w = wrapper.offsetWidth;
        var h = wrapper.offsetHeight;
        var r = parseFloat(getComputedStyle(link).getPropertyValue('--border-radius')) || 0;
        // 周长近似（含圆角修正）
        var perimeter = 2 * (w + h) - (8 - 2 * Math.PI) * r;
        rect.setAttribute('x', '0');
        rect.setAttribute('y', '0');
        rect.setAttribute('width', w);
        rect.setAttribute('height', h);
        rect.setAttribute('rx', '0');
        rect.setAttribute('ry', '0');
        rect.style.strokeDasharray = perimeter;
        rect.style.strokeDashoffset = perimeter;
        link._orbitPerimeter = perimeter;
      }

      setDash();
      window.addEventListener('resize', setDash);

      link.addEventListener('mouseenter', function () {
        rect.style.strokeDashoffset = '0';
      });
      link.addEventListener('mouseleave', function () {
        rect.style.strokeDashoffset = link._orbitPerimeter;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrbit);
  } else {
    initOrbit();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-elastic-arrow"] && !Shopify.designMode) return;
  try {
    (function () {

  function initElasticArrows() {
    document.querySelectorAll('.simp-elastic-arrow:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '1');

      var ctx  = gsap.context(function () {
        var wrap  = el.querySelector('.simp-elastic-arrow__wrap');
        var group = el.querySelector('.simp-elastic-arrow__group');
        var shaft = el.querySelector('.simp-elastic-arrow__shaft');
        var hTop  = el.querySelector('.simp-elastic-arrow__head-top');
        var hBot  = el.querySelector('.simp-elastic-arrow__head-bottom');
        if (!wrap || !group || !shaft) return;

        var s = el;
        var travel    = parseFloat(el.dataset.travel   || '12');
        var ampEnter  = parseFloat(el.dataset.ampEnter || '1.2');
        var ampLeave  = parseFloat(el.dataset.ampLeave || '1.6');
        var perEnter  = parseFloat(el.dataset.perEnter || '0.5');
        var perLeave  = parseFloat(el.dataset.perLeave || '0.4');
        var durEnter  = parseFloat(el.dataset.durEnter || '0.6');
        var durLeave  = parseFloat(el.dataset.durLeave || '0.9');

        // 箭头路径基准
        var xDefault  = 168;
        var xHover    = xDefault + travel;
        var armX = 8, armY = 7;

        function paths(x) {
          var qx = 134 + (x - 134) * 0.6;
          return {
            shaft: 'M 134,12 Q ' + qx + ',12 ' + x + ',12',
            hTop:  'M ' + (x - armX) + ',' + (12 - armY) + ' L ' + x + ',12',
            hBot:  'M ' + (x - armX) + ',' + (12 + armY) + ' L ' + x + ',12'
          };
        }

        var DEFAULT   = paths(xDefault);
        var HOVER     = paths(xHover);
        var OVERSHOOT = paths(xDefault - 4);

        // ── idle 旋转 timeline ──────────────────────────────
        var idleTL = gsap.timeline({ repeat: -1, paused: true })
          // 停顿在正面
          .to(group, { rotationX: 0,   duration: 1.5, ease: 'none' })
          // 加速转出
          .to(group, { rotationX: 180, duration: 0.8, ease: 'power2.in' })
          // 减速转回
          .to(group, { rotationX: 360, duration: 0.8, ease: 'power2.out' })
          // 重置（无缝循环）
          .set(group, { rotationX: 0 });

        function startIdle() {
          gsap.set(group, { rotationX: 0 });
          idleTL.restart();
          idleTL.play();
        }

        function stopIdle() {
          idleTL.pause();
          gsap.set(group, { rotationX: 0 });
        }

        // 启动 idle
        startIdle();

        // ── 交互动画 ────────────────────────────────────────
        function killInteraction() {
          gsap.killTweensOf([shaft, hTop, hBot]);
        }

        function animTo(target, duration, ease, delay) {
          gsap.to(shaft, { attr: { d: target.shaft }, duration: duration, ease: ease, delay: delay || 0 });
          gsap.to(hTop,  { attr: { d: target.hTop  }, duration: duration, ease: ease, delay: (delay || 0) + 0.04 });
          gsap.to(hBot,  { attr: { d: target.hBot  }, duration: duration, ease: ease, delay: (delay || 0) + 0.04 });
        }

        function onEnter() {
          stopIdle();
          killInteraction();
          animTo(HOVER, durEnter, 'elastic.out(' + ampEnter + ',' + perEnter + ')');
        }

        function onLeave() {
          killInteraction();
          animTo(OVERSHOOT, 0.12, 'power2.in');
          animTo(DEFAULT, durLeave, 'elastic.out(' + ampLeave + ',' + perLeave + ')', 0.12);
          // 回弹结束后重启 idle
          gsap.delayedCall(durLeave + 0.12 + 0.8, startIdle);
        }

        // 鼠标
        wrap.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          onEnter();
        });
        wrap.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          onLeave();
        });

        // 触摸
        wrap.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse') return;
          onEnter();
        });
        wrap.addEventListener('pointerup', function (e) {
          if (e.pointerType === 'mouse') return;
          onLeave();
        });
        wrap.addEventListener('pointercancel', function (e) {
          if (e.pointerType === 'mouse') return;
          onLeave();
        });

      }, el); // gsap.context 绑定到 el

      // 编辑器清理
      document.addEventListener('shopify:block:deselect', function (e) {
        if (e.target === el || el.contains(e.target)) {
          ctx.revert();
        }
      }, { once: true });

    });
  }

  function waitForGSAP(cb) {
    if (window.gsap) { cb(); return; }
    setTimeout(function () { waitForGSAP(cb); }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForGSAP(initElasticArrows); });
  } else {
    waitForGSAP(initElasticArrows);
  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-inflate-arrow"] && !Shopify.designMode) return;
  try {
    (function () {

  function initInflateArrows() {
    document.querySelectorAll('.simp-inflate-arrow:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '1');

      var wrap      = el.querySelector('.simp-inflate-arrow__wrap');
      var shaft     = el.querySelector('.simp-inflate-arrow__shaft');
      var clip      = el.querySelector('.simp-inflate-arrow__clip');
      var textPath  = el.querySelector('defs [id^="simp-text-path"]');
      var arrow     = el.querySelector('.simp-inflate-arrow__arrow');
      if (!wrap || !shaft) return;

      var dir   = el.dataset.direction === 'down' ? 1 : -1;
      var bulge = parseFloat(el.dataset.bulge || '100');
      var curveFactor = 1.4;
      var baseY = 100;
      // ClipPath 始终闭合到远端，箭头区域永远在可见区内
      var clipBoundary = (dir === -1) ? 200 : 0;

      var D_DEFAULT = 'M 10,' + baseY + ' Q 200,' + baseY + ' 390,' + baseY;
      var D_HOVER   = 'M 10,' + baseY + ' Q 200,' + (baseY + dir * bulge * curveFactor) + ' 390,' + baseY;
      
      var C_DEFAULT = D_DEFAULT + ' L 390,' + clipBoundary + ' L 10,' + clipBoundary + ' Z';
      var C_HOVER   = D_HOVER   + ' L 390,' + clipBoundary + ' L 10,' + clipBoundary + ' Z';

      // 箭头初始完全透明，位置固定在基准线
      gsap.set(arrow, { opacity: 0 });

      function kill() {
        gsap.killTweensOf([shaft, clip, textPath, arrow]);
      }

      function onEnter() {
        kill();
        // 线条 + clipPath + 文字路径同步充气
        gsap.to([shaft, textPath], {
          attr: { d: D_HOVER },
          duration: 0.9,
          ease: 'elastic.out(1.2, 0.4)'
        });
        gsap.to(clip, {
          attr: { d: C_HOVER },
          duration: 0.9,
          ease: 'elastic.out(1.2, 0.4)'
        });
        // 箭头快速直接显示（几乎无延迟，配合线条弹性节奏）
        // 箭头快速显示 + 启动循环动画
        gsap.to(arrow, {
        opacity: 1,
        duration: 0.12,
        ease: 'power2.out',
        delay: 0.12,
        onComplete: function() {
            // 🔄 循环动画：显示后开始
/*            gsap.to(arrow, {
            y: -4,                      // 上下浮动幅度（像素）
            duration: 0.7,              // 单次周期时长
            ease: 'sine.inOut',         // 平滑正弦曲线
            repeat: -1,                 // 无限循环
            yoyo: true                  // 往返运动
            }); 
            */
          gsap.to(arrow, {
            rotation: 3,
            transformOrigin: 'center center',
            duration: 0.5,
            ease: 'sine.inOut',
            repeat: -1,
            yoyo: true
            }); 
 /*             gsap.to(arrow, {
  scale: 1.15,
  transformOrigin: 'center center',
  duration: 0.6,
  ease: 'sine.inOut',
  repeat: -1,
  yoyo: true
});*/
        }
        });
      }

      function onLeave() {
        kill();
        gsap.to([shaft, textPath], {
          attr: { d: D_DEFAULT },
          duration: 1.4,
          ease: 'sine.out'
        });
        gsap.to(clip, {
          attr: { d: C_DEFAULT },
          duration: 1.4,
          ease: 'sine.out'
        });
 
        // 箭头慢慢消失 + 清除循环动画
        gsap.killTweensOf(arrow);  // 🛑 停止所有循环
        gsap.to(arrow, {
        opacity: 0,
        y: 0,                    // 重置位置
        scale: 1,                // 重置缩放
        rotation: 0,             // 重置旋转
        duration: 0.9,
        ease: 'sine.out',
        delay: 0.25
        });
      }

      wrap.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        onEnter();
      });
      wrap.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        onLeave();
      });

      wrap.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        onEnter();
      });
      wrap.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'mouse') return;
        onLeave();
      });
      wrap.addEventListener('pointercancel', function (e) {
        if (e.pointerType === 'mouse') return;
        onLeave();
      });
    });
  }

  function waitForGSAP(cb) {
    if (window.gsap) { cb(); return; }
    setTimeout(function () { waitForGSAP(cb); }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForGSAP(initInflateArrows); });
  } else {
    waitForGSAP(initInflateArrows);
  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-review-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function initReviewCards() {
    document.querySelectorAll('.simp-review-card').forEach(function (card) {
      var content = card.querySelector('.simp-review-card__content');
      var fold = card.querySelector('.simp-review-card__fold');
      if (!content || !fold) return;

      // 量出折叠高度（名称+星星+2行预览 + padding）
      var foldHeight = fold.offsetHeight;
      var paddingBottom = 16;
      var paddingTop = 32;
      var collapsedHeight = foldHeight + paddingBottom + paddingTop;

      // 完整高度
      var fullHeight = content.scrollHeight;

      // 默认偏移 = 完整高度 - 折叠高度
      var offset = fullHeight - collapsedHeight;
      if (offset < 0) offset = 0;

      content.style.setProperty('--slide-offset', offset + 'px');

      // 桌面端 hover
      card.addEventListener('mouseenter', function () {
        card.classList.add('is-hovered');
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-hovered');
      });

      // 移动端 tap toggle
      card.addEventListener('click', function () {
        card.classList.toggle('is-hovered');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewCards);
  } else {
    initReviewCards();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-twist-arrow"] && !Shopify.designMode) return;
  try {
    (function() {
  function init() {
    document.querySelectorAll('.simp-twist-arrow').forEach(function(el, idx) {
      var uid = 'simp-track-' + idx + '-' + Date.now();

      var track      = el.querySelector('.js-track');
      var arrowUpper = el.querySelector('.js-arrow-upper');
      var arrowLower = el.querySelector('.js-arrow-lower');
      var textPath   = el.querySelector('.js-textpath');
      var svg        = el.querySelector('svg');
      var wrap       = el.querySelector('.simp-twist-arrow__wrap');

      if (!track || !textPath) return;

      track.setAttribute('id', uid);
      textPath.setAttribute('href', '#' + uid);

      var VIEW_WIDTH = 600; // 🔑 固定画布基准宽度（可按需微调）
      var startX = 0;       // 初始占位，后续动态计算
      var gap     = 10;
      var y       = 24;
      var textW   = 0;
      var hideLen = 0;
      var state   = 'IDLE';
      
      var anim = { visibleLen: 90, shiftX: 0, amp: 0, freq: 1, phase: 0, openAngle: Math.PI/4 };
      var ARROW_LEN = 18;
      
      var pathTween = null;
      var rotTween  = null;

      function genPath(totalLen, amp, freq, phase, shiftX) {
        var pts = [`M ${startX + shiftX},${y}`]; 
        var steps = 48;
        for (var i = 1; i <= steps; i++) {
          var t = i / steps;
          var x = startX + shiftX + totalLen * t;
          var waveY = y + amp * Math.sin(freq * Math.PI * 2 * t + phase);
          pts.push(`L ${x.toFixed(2)},${waveY.toFixed(2)}`);
        }
        return pts.join(' ');
      }

      function updateArrow(ex, ey, halfAngle) {
        var dx = ARROW_LEN * Math.cos(halfAngle);
        var dy = ARROW_LEN * Math.sin(halfAngle);
        var exF = ex.toFixed(2), eyF = ey.toFixed(2);
        var lx = (ex - dx).toFixed(2);
        arrowUpper.setAttribute('x1', lx); arrowUpper.setAttribute('y1', (ey - dy).toFixed(2));
        arrowUpper.setAttribute('x2', exF); arrowUpper.setAttribute('y2', eyF);
        arrowLower.setAttribute('x1', lx); arrowLower.setAttribute('y1', (ey + dy).toFixed(2));
        arrowLower.setAttribute('x2', exF); arrowLower.setAttribute('y2', eyF);
      }

      function syncPath() {
        if (!track) return;
        var totalLen = hideLen + anim.visibleLen;
        track.setAttribute('d', genPath(totalLen, anim.amp, anim.freq, anim.phase, anim.shiftX));
        
        var actualLen = track.getTotalLength();
        var endPt = track.getPointAtLength(actualLen);
        updateArrow(endPt.x, endPt.y, anim.openAngle);
        
        // 🔑 修复1：强制平头消除圆帽溢出点 + 精准偏移遮罩
      track.style.strokeLinecap = 'butt';
      // 🔑 核心修复：遮罩跳过长度直接锁定为初始化计算的 hideLen，彻底解耦波浪形变
      track.style.strokeDasharray = `0, ${hideLen}, 9999`;
      }

      function startRotation() {
        if (rotTween) rotTween.kill();
        rotTween = gsap.to(anim, {
          openAngle: 0, duration: 0.45, repeat: -1, yoyo: true, ease: "sine.inOut", onUpdate: syncPath
        });
      }

      function killPath() {
        if (pathTween) { pathTween.kill(); pathTween = null; }
      }

      function snapToStart() {
        killPath(); if (rotTween) { rotTween.kill(); rotTween = null; }
        anim.visibleLen = 90; anim.shiftX = 0; anim.amp = 0; anim.freq = 1; anim.phase = 0;
        anim.openAngle = Math.PI/4;
        syncPath();
      }

      function calculateLayout() {
        textW = textPath.getComputedTextLength();
        if (textW < 5) { requestAnimationFrame(calculateLayout); return; }
        hideLen = textW + gap;
        // 🔑 核心：动态反推起点，让文字起始点天生落在画布正中心 (300)
        // 🔑 按默认整体可见长度居中：文字 + 间隔(10) + 初始箭头(90)
        var defaultVisibleLen = 90;
        var totalVisualLen = textW + gap + defaultVisibleLen;
        startX = (VIEW_WIDTH / 2) - (totalVisualLen / 2);

        anim.visibleLen = 90; anim.shiftX = 0; anim.openAngle = Math.PI/4;
        syncPath();

        // 🔑 锁定 viewBox，消除动态缩放导致的视觉偏移
        svg.setAttribute('viewBox', `0 0 ${VIEW_WIDTH} 48`);
      }

      // 1. CHARGE: 3s 压缩（🔑 修复2：大幅左移35px，产生强烈向左抽拉感）
      function doCharge() {
        killPath();
        if (state !== 'IDLE' && state !== 'CHARGE') snapToStart();
        state = 'CHARGE';
        startRotation();
        
        pathTween = gsap.to(anim, {
          visibleLen: 90, shiftX: -35, amp: 8, freq: 4, phase: Math.PI * 5,
          duration: 3, ease: 'power4.out', onUpdate: syncPath, onComplete: doFire
        });
      }

      // 2. FIRE: 1.5s 弹射
      function doFire() {
        if (state !== 'CHARGE') return;
        state = 'FIRE';
        killPath();
        pathTween = gsap.to(anim, {
          visibleLen: 190, shiftX: 50, amp: 0, freq: 1, phase: 0,
          duration: 1.5, ease: 'power2.out', onUpdate: syncPath,
          onComplete: function() { state = 'HOLD'; pathTween = null; }
        });
      }

      // 3. RETURN: 6s 归位
      function doReturn() {
        if (state === 'IDLE') return;
        state = 'RETURN';
        killPath();
        startRotation(); // 回来全程保持张口旋转
        pathTween = gsap.to(anim, {
          visibleLen: 90, shiftX: 0, amp: 0, freq: 1, phase: 0,
          duration: 6, ease: 'power2.out', onUpdate: syncPath,
          onComplete: function() { 
            state = 'IDLE'; pathTween = null;
            if (rotTween) rotTween.kill();
            anim.openAngle = Math.PI/4; anim.shiftX = 0;
            syncPath();
          }
        });
      }

      wrap.addEventListener('pointerenter', function(e) { if (e.pointerType !== 'mouse') return; doCharge(); });
      wrap.addEventListener('pointerleave', function(e) { if (e.pointerType !== 'mouse') return; doReturn(); });
      wrap.addEventListener('pointerdown', function(e) { if (e.pointerType === 'mouse') return; doCharge(); });
      wrap.addEventListener('pointerup', function(e) { if (e.pointerType === 'mouse') return; doReturn(); });

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(calculateLayout);
      else window.addEventListener('load', calculateLayout);
    });
  }
  
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simp-video-card"] && !Shopify.designMode) return;
  try {
    (function () {
  // ── 单例 Modal：只创建一次，直接挂到 body ──
  function getOrCreateModal() {
    var existing = document.getElementById('simp-video-modal-singleton');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = 'simp-video-modal-singleton';
    modal.className = 'simp-video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', '视频播放');
    modal.innerHTML = [
      '<div class="simp-video-modal__backdrop"></div>',
      '<div class="simp-video-modal__dialog">',
        '<button class="simp-video-modal__close" aria-label="关闭">',
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"',
          ' fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
            '<line x1="18" y1="6" x2="6" y2="18"/>',
            '<line x1="6" y1="6" x2="18" y2="18"/>',
          '</svg>',
        '</button>',
        '<div class="simp-video-modal__iframe-wrap"></div>',
      '</div>'
    ].join('');

    // ✅ 直接挂到 body，完全脱离任何父级容器
    document.body.appendChild(modal);

    var backdrop  = modal.querySelector('.simp-video-modal__backdrop');
    var closeBtn  = modal.querySelector('.simp-video-modal__close');
    var iframeWrap = modal.querySelector('.simp-video-modal__iframe-wrap');

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('simp-modal-open');
      iframeWrap.innerHTML = ''; // 销毁 iframe，停止播放
    }

    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    return modal;
  }

  function buildEmbedUrl(platform, videoId) {
    if (platform === 'youtube') return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
    if (platform === 'vimeo')   return 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
    if (platform === 'tiktok')  return 'https://www.tiktok.com/embed/' + videoId;
    return '';
  }

  function initSimpVideoCards() {
    document.querySelectorAll('.simp-video-card:not([data-simp-init])').forEach(function (card) {
      card.dataset.simpInit = '1';

      var btn = card.querySelector('.simp-video-card__play-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var platform = card.dataset.platform;
        var videoId  = card.dataset.videoId;
        var embedUrl = buildEmbedUrl(platform, videoId);
        if (!embedUrl) return;

        var modal      = getOrCreateModal();
        var iframeWrap = modal.querySelector('.simp-video-modal__iframe-wrap');

        iframeWrap.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        modal.classList.add('is-open');
        document.body.classList.add('simp-modal-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSimpVideoCards);
  } else {
    initSimpVideoCards();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
